import { createContext, useEffect, useState } from "react";

const Context = createContext({});

const ContextProvider = ({ children, value }) => {
    const [categories, setCategories] = useState([
        {
            name: "TIMEKEEPER",
            endpoints: [
                {
                    id: "GetResultTotalize",
                    name: "Get Result Totalize",
                    method: "GET",
                    url: "/v1/result_totalize",
                },
                {
                    id: "GetPayCodeAssign",
                    name: "Get Pay Code Assign",
                    method: "GET",
                    url: "/v1/paycode_assign",
                },
                {
                    id: "GetGeneralSystem_info",
                    name: "Get General System Info",
                    method: "GET",
                    url: "/v1/config_system"
                }
            ]
        },
        {
            name: "SCHEDULER",
            endpoints: [
                {
                    id: "GetScheduler",
                    name: "Get Scheduler",
                    method: "GET",
                    url: "/v1/shift/schedule"
                }
            ]
        },
        {
            name: "EMPLOYEES",
            endpoints: [
                {
                    id: "GetInfoSubCompanyByID",
                    name: "Get Info Sub Company By ID",
                    method: "GET",
                    url: "/v1/sub_company/<<id_subcompany>>"
                },
                {
                    id: "GetEmployee",
                    name: "Get Employee",
                    method: "GET",
                    url: "/v1/employee"
                }
            ]
        },
        {
            name: "AUTH",
            endpoints: []
        }
    ])

    const [queries, setQueries] = useState([])
    const [params, setParams] = useState([])
    const [apis, setApis] = useState([])

    const [loadingReport, setLoadingReport] = useState(false)
    const [loadingUpdate, setLoadingUpdate] = useState(false)

    useEffect(() => {
        console.log('data: ', categories)

    }, [categories])

    return (
        <Context.Provider
            value={{
                ...value,
                categories, setCategories,
                queries, setQueries,
                params, setParams,
                apis, setApis,
                loadingReport, setLoadingReport,
                loadingUpdate, setLoadingUpdate,
            }}
        >
            { children }
        </Context.Provider>
    )
}

export {
    Context,
    ContextProvider
}